// extracted by mini-css-extract-plugin
export default {"container":"popover_loading-module__container--3kPG7","loader":"popover_loading-module__loader--1HPWr"};